import UnAuthenticatedRequest from 'services/requests/UnAuthenticated';
import apiUrlConfig from 'configs/apiUrlConfig';

const URLS = {
  BOOK: `${apiUrlConfig.apiEndPoint()}/social_events`,
};

class SoonoEventApi {
  static book(eventData) {
    return UnAuthenticatedRequest.post(URLS.BOOK, {
      social_event: eventData,
    });
  }
}

export default SoonoEventApi;



// WEBPACK FOOTER //
// ./src/apis/SoonoEvent.js